import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { actions } from '../reducers/regions'
import { types as authTypes } from '../reducers/auth'

import { apolloClient } from '@fe/business/src/apollo'

import * as snack from './snackMessage'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

const MY_REGION_ROLES_QUERY = gql`
  query MyRegionRoles {
    RegionsQuery {
      myRegionRoles {
        region {
          id
        }
        roles
      }
    }
  }
`

export function * loadRegionsEffect () {
  try {
    const response = yield call([apolloClient, apolloClient.query], {
      query: MY_REGION_ROLES_QUERY,
      fetchPolicy: 'network-only'
    })
    const regionRoles = _.getOr([], 'data.RegionsQuery.myRegionRoles', response)
    return _.map(({ region, roles }) => ({ region: region.id, roles }), regionRoles)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

/**
 * takeLatest(types.LOAD_REQUEST, loadClubsFlow)
 */
export function * loadRegionsFlow ({ payload }) {
  const regions = yield call(loadRegionsEffect, payload)
  if (regions.error) {
    yield put(actions.loadError(regions))
    yield snack.genericError(regions.error)
  } else {
    yield put(actions.loadSuccess(regions))
  }
}

export default function * () {
  return yield all([
    takeLatest(authTypes.BOOTSTRAP_DONE, loadRegionsFlow)
  ])
}
